import { api } from "./api";
import { callAuthApi } from "../helpers/";

const callApiFetchWhiteLabelBusinessUsers = async (businessId) => {
  if (callAuthApi()) {
    return await api.service("users").find({});
  } else {
    return null;
  }
};

const callApiFetchBusinessUsers = async (subdomain) => {
  // if (callAuthApi()) {
  if (1) {
    console.log("Here now 1111111111111111");
    const businessData = await api
      .service("businesses")
      .find({ subdomain: subdomain });

    console.log("businessData", businessData);

    return await api
      .service("users")
      .find({ businessDetails: { $elemMatch: { businessId: "" } } });
  } else {
    return null;
  }
};

const callApiBusinessesList = async (data) => {
  if (callAuthApi()) {
    return await api.service("api/businesses").find({});
  } else {
    return null;
  }
};

const callApiWhiteLabelBusinessesList = async () => {
  if (callAuthApi()) {
    console.log("calling ...");

    return await api
      .service("businesses")
      .find({ businessType: "white-label" });
  } else {
    return null;
  }
};

const callApiUpdateBusiness = async (data) => {
  if (callAuthApi()) {
    return await api.service("api/businesses").create(data);
  } else {
    return null;
  }
};

const callApiGetBusiness = async (id) => {
  if (callAuthApi()) {
    return await api.service("businesses").get(id);
  } else {
    return null;
  }
};

const callApiGetBusinessIdUsingSubdomain = async (subdomain) => {
  if (callAuthApi()) {
    return await api.service("businesses").find({ query: { subdomain } });
  } else {
    return null;
  }
};

export {
  callApiFetchWhiteLabelBusinessUsers,
  callApiFetchBusinessUsers,
  callApiBusinessesList,
  callApiUpdateBusiness,
  callApiWhiteLabelBusinessesList,
  callApiGetBusiness,
  callApiGetBusinessIdUsingSubdomain,
};
